











import { Prop, Component, Vue } from "vue-property-decorator";
import { Conciseness as ConcisenessClass } from "@/types/NewResults";
import Directness from "./concise/Directness.vue";
import Repetition from "./concise/Repetition.vue";
import SentenceLength from "./concise/SentenceLength.vue";
@Component({
  components: { Directness, Repetition, SentenceLength }
})
export default class Conciseness extends Vue {
  @Prop() private conciseness!: ConcisenessClass;
}
